import React from 'react';
import { connect } from 'react-redux';
import { selectHasSingleNonPinnedVariable } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { EngravingInputControlWindow } from './EngravingInputControlWindow';
import { EngravingInputOptionGrid } from './EngravingInputOptionGrid';

const _EngravingInputControlMobile = ({ hasSingleNonPinnedVariable, isContentFirst, ...props }: Props) => {
    if (hasSingleNonPinnedVariable && !isContentFirst) {
        return <EngravingInputOptionGrid {...props} />;
    } else {
        return <EngravingInputControlWindow {...props} />;
    }
};

type Props = {
    name: string;
    variableIds: string[];
    selectedAssetUrl: string;
    openByDefault: boolean;
    shouldDisplayIcon: boolean;
    hasSingleNonPinnedVariable: boolean;
    isContentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasSingleNonPinnedVariable: selectHasSingleNonPinnedVariable(state),
    isContentFirst: state.scene.options?.contentFirst ?? false
});

export const EngravingInputControlMobile = connect(
    mapStateToProps
)(_EngravingInputControlMobile);